import { ITEM_TYPE_DA_INOX, ITEM_TYPE_DA_KHONG, ITEM_TYPE_LENDA, ITEM_TYPE_LEN_DA, ITEM_TYPE_LEN_INOX, ITEM_TYPE_LEN_KHONG, ITEM_TYPE_NONE, ITEM_TYPE_NORMAL, STATUS_DA_DA_SX, STATUS_DA_HOAN_THANH, STATUS_DA_MOI, STATUS_LEN_DA_SX, STATUS_LEN_HOAN_THANH, STATUS_LEN_MOI, STATUS_SS_SX_DA, STATUS_SS_SX_LEN } from "../constants";

export const OPTIONS_SEP = ',';
export const OPTIONS_VAL_SEP_COLON = ':';
export const OPTIONS_SUB_SEP_UNDERSCORE = '_';
export const OPTIONS_SUB_SEP_AND = '&';
export const OPTIONS_SUB_SEP_OR = '|';

class WorkOrderUtil {
    
    //Ring size: 7 1/2 US, Ring Material & Band Style: GOLD | TWISTED, Personalization: October and March
    //Color_Number of Letters: GOLD_6-10 letters, Length: 14 IN, Personalization: Barbara
    extractOptions(options){
        var result = [];
        let arrOptions = options.split(`${OPTIONS_SEP}`);
        for(var i=0; i<arrOptions.length; i++){
            result.push(this.extractSubOptions(arrOptions[i]));
        }
        return result;
    }

    getStatusDescription(allStatus, status){
        if (allStatus === undefined || allStatus === null){
            return status;
        }    
        let istatus = parseInt(status);
        let statusInfo = allStatus.find(x =>{
        return x.status === istatus;
        });
        if (statusInfo !== undefined){
        return statusInfo.statusDescVn;
        }   
        return status;     
    }

    getLenStatusDescription(status){
        if (status === STATUS_LEN_MOI){
            return "";
        }

        if (status === STATUS_SS_SX_LEN){
            return "Sẵn sàng sx len";
        }

        if (status === STATUS_LEN_HOAN_THANH){
            return "Len Hoàn thành";
        }

        if (status === STATUS_LEN_DA_SX){
            return "Len đã sx";
        }
        return status;     
    }

    getLenStatusDescription2(wo){
        if (wo.itemType === ITEM_TYPE_NONE || wo.itemType === ITEM_TYPE_DA_KHONG || wo.itemType === ITEM_TYPE_DA_INOX){
            return "";
        }
        
        let status = wo.lenStatus;
        if (status === STATUS_LEN_MOI){
            return "";
        }

        if (status === STATUS_SS_SX_LEN){
            return "Sẵn sàng sx len";
        }

        if (status === STATUS_LEN_HOAN_THANH){
            return "Len Hoàn thành";
        }

        if (status === STATUS_LEN_DA_SX){
            return "Len đã sx";
        }
        return status;     
    }

    getDaStatusDescription(status){
        if (status === STATUS_DA_MOI){
            return "";
        }

        if (status === STATUS_SS_SX_DA){
            return "Sẵn sàng sx da";
        }

        if (status === STATUS_DA_HOAN_THANH){
            return "Da Hoàn thành";
        }

        if (status === STATUS_DA_DA_SX){
            return "Da đã sx";
        }
        return status;     
    }

    getDaStatusDescription2(wo){
        if (wo.itemType === ITEM_TYPE_NONE || wo.itemType === ITEM_TYPE_LEN_KHONG || wo.itemType === ITEM_TYPE_LEN_INOX){
            return "";
        }

        let status = wo.daStatus;
        if (status === STATUS_DA_MOI){
            return "";
        }

        if (status === STATUS_SS_SX_DA){
            return "Sẵn sàng sx da";
        }

        if (status === STATUS_DA_HOAN_THANH){
            return "Da Hoàn thành";
        }

        if (status === STATUS_DA_DA_SX){
            return "Da đã sx";
        }
        return status;     
    }

    datGhiThiepDesc(wo){
        let ret = "";
        if (wo.ghiThiep === 1 || wo.ghiThiep === '1'){
            ret += "X";
        }

        ret += "(" + wo.weightOZ + ")";
        return ret;
    }

    getItemTypeDescription(itype){
        if (itype === ITEM_TYPE_NONE){
            return "";
        }

        if (itype === ITEM_TYPE_LEN_KHONG){
            return "Len không";
        }

        if (itype === ITEM_TYPE_LEN_DA){
            return "Len & Da";
        }

        if (itype === ITEM_TYPE_DA_KHONG){
            return "Da không";
        }

        if (itype === ITEM_TYPE_LEN_INOX){
            return "Len& Inox";
        }

        if (itype === ITEM_TYPE_DA_INOX){
            return "Da & Inox";
        }
        return itype;     
    }

    getValueDescription(allStatus, status, valueName){
        if (allStatus === undefined || allStatus === null || valueName !== 'status'){
            return status;
        }    
        let istatus = parseInt(status);
        let statusInfo = allStatus.find(x =>{
        return x.status === istatus;
        });
        if (statusInfo !== undefined){
        return statusInfo.statusDescVn;
        }   
        return status;     
    }

    getAssignInfo(filename){
        try {
			let idx1 = filename.indexOf("_");
			let idx2 = filename.indexOf(".");
            if (idx1 > 0){
                let s = filename.substring(idx1 + 1, idx2);
                return s.substring(0, 4) + "/" + s.substring(4,6) + "/" + s.substring(6,8) + ", " + s.substring(9,s.length)
            }
            return filename;
		} catch (e) {

		}
        return filename;
    }   
    
    extractSubOptions(option){

        let result = {};
        let arrOptions = option.split(`${OPTIONS_VAL_SEP_COLON}`);
        if (arrOptions.length !== 2){
            result['option'] = option;
            return result;
        }

        let key = arrOptions[0];
        let value = arrOptions[1];

        var i = 0;

        //sub options are separated by OPTIONS_SUB_SEP_UNDERSCORE
        if (key.indexOf(`${OPTIONS_SUB_SEP_UNDERSCORE}`) > 0){
            let subKeys = key.split(`${OPTIONS_SUB_SEP_UNDERSCORE}`);
            let subValues = value.split(`${OPTIONS_SUB_SEP_UNDERSCORE}`);
            for(i=0; i<subKeys.length; i++){
                result[subKeys[i]] = subValues[i];
            }
            return result;
        } 

        //sub options are separated by OPTIONS_SUB_SEP_AND
        if (key.indexOf(`${OPTIONS_SUB_SEP_AND}`) > 0){
            let subKeys = key.split(`${OPTIONS_SUB_SEP_AND}`);
            let subValues = value.split(`${OPTIONS_SUB_SEP_AND}`);
            if (subValues.length < subKeys.length){
                subValues = value.split(`${OPTIONS_SUB_SEP_OR}`);
            }
            for(i=0; i<subKeys.length; i++){
                result[subKeys[i]] = subValues[i];
            }
            return result;
        }

        result[key] = value;
        return result; 
    }

    formatDisplayDateMMddyyyy(yyyyMMddDate){
        if ((yyyyMMddDate === null) || (yyyyMMddDate === undefined)){
            return null;
        }
        var dateSep = '/';
        var dateTimeSep = ' ';
        var timeSep = ':';

        var parts = null;
        var timeParts = null;
        var dateTimeParts = yyyyMMddDate.split(dateTimeSep);
        if (dateTimeParts.length > 0){
            parts = dateTimeParts[0].split(dateSep);
            if (dateTimeParts.length > 1){
                timeParts = dateTimeParts[1].split(timeSep);
            }
        }
        if (parts === null){
            return null;
        }

        var mydate = null;
        if ((timeParts === null) || (timeParts === undefined) || (timeParts.length < 1)){
            mydate = parts[1] + dateSep + parts[2] + dateSep + parts[0] + dateTimeSep + "00" + timeSep + "00"; 
        }else{
            mydate = parts[1] + dateSep + parts[2] + dateSep + parts[0] + dateTimeSep + timeParts[0] + timeSep + timeParts[1]; 
        }
        return mydate;
    }

    formatShortDisplayDateMMddyyyy(yyyyMMddDate){
        if ((yyyyMMddDate === null) || (yyyyMMddDate === undefined)){
            return null;
        }
        var dateSep = '/';
        var dateTimeSep = ' ';

        var parts = null;
        var dateTimeParts = yyyyMMddDate.split(dateTimeSep);
        if (dateTimeParts.length > 0){
            parts = dateTimeParts[0].split(dateSep);
        }
        if (parts === null){
            return null;
        }

        var mydate = parts[1] + dateSep + parts[2] + dateSep + parts[0]; 
        return mydate;
    }

    formatShortDisplayDateMMddyyyy2(yyyyMMddDate){
        if ((yyyyMMddDate === null) || (yyyyMMddDate === undefined)){
            return null;
        }
        var dateSep = '-';
        var dateSep2 = '/';
        var dateTimeSep = 'T';

        var parts = null;
        var dateTimeParts = yyyyMMddDate.split(dateTimeSep);
        if (dateTimeParts.length > 0){
            parts = dateTimeParts[0].split(dateSep);
        }
        if (parts === null){
            return null;
        }

        var mydate = parts[1] + dateSep2 + parts[2] + dateSep2 + parts[0]; 
        return mydate;
    }

    formatShortDisplayDateMMddyyyy2_1(yyyyMMddDate){
        if ((yyyyMMddDate === null) || (yyyyMMddDate === undefined)){
            return null;
        }
        try{
            var dateSep = '-';
            var dateSep2 = '/';
            var dateTimeSep = ' ';

            var parts = null;
            var dateTimeParts = yyyyMMddDate.split(dateTimeSep);
            if (dateTimeParts.length > 0){
                parts = dateTimeParts[0].split(dateSep);
            }
            if (parts === null){
                return null;
            }

            var mydate = parts[1] + dateSep2 + parts[2] + dateSep2 + parts[0]; 
            return mydate;
        }catch(e){
            return null;
        }
    }    

    formatShortDisplayDateMMddyyyy3(yyyyMMddDate){
        if ((yyyyMMddDate === null) || (yyyyMMddDate === undefined)){
            return null;
        }
        var dateSep = '-';
        var dateSep2 = '/';
        var dateTimeSep = 'T';

        var parts = null;
        var dateTimeParts = yyyyMMddDate.split(dateTimeSep);
        if (dateTimeParts.length > 0){
            parts = dateTimeParts[0].split(dateSep);
        }
        if (parts === null){
            return null;
        }

        var mydate = parts[1] + dateSep2 + parts[2] + dateSep2 + parts[0]; 
        return mydate;
    } 

    formatShortDisplayDateMMddyyyy4(yyyyMMddDate){
        if ((yyyyMMddDate === null) || (yyyyMMddDate === undefined)){
            return null;
        }
        var dateSep = '-';
        var dateSep2 = '/';
        var dateTimeSep = ' ';

        var parts = null;
        var dateTimeParts = yyyyMMddDate.split(dateTimeSep);
        if (dateTimeParts.length > 0){
            parts = dateTimeParts[0].split(dateSep);
        }
        if (parts === null){
            return null;
        }

        var mydate = parts[0] + dateSep2 + parts[1] + dateSep2 + parts[2]; 
        return mydate;
    }             

    convertToDate(yyyyMMddDate){
        if ((yyyyMMddDate === null) || (yyyyMMddDate === undefined) || (yyyyMMddDate === '')){
            return null;
        }
        var dateSep = '/';
        var dateTimeSep = ' ';
        var timeSep = ':';

        var parts = null;
        var timeParts = null;
        var dateTimeParts = yyyyMMddDate.split(dateTimeSep);
        if (dateTimeParts.length > 0){
            parts = dateTimeParts[0].split(dateSep);
            if (dateTimeParts.length > 1){
                timeParts = dateTimeParts[1].split(timeSep);
            }
        }
        if (parts === null){
            return null;
        }

        var mydate = null;
        if ((timeParts === null) || (timeParts === undefined) || (timeParts.length < 1)){
            mydate = new Date(parts[0], parts[1]-1, parts[2]); 
        }else{
            mydate = new Date(parts[0], parts[1]-1, parts[2], timeParts[0], timeParts[1]); 
        }
        return mydate;
    }

    convertToDate2(yyyyMMddDate){
        if ((yyyyMMddDate === null) || (yyyyMMddDate === undefined)){
            return null;
        }
        var dateSep = '-';
        var dateTimeSep = 'T';
        if (yyyyMMddDate.indexOf("T") < 0){
            return this.convertToDate3(yyyyMMddDate);
        }
        var timeSep = ':';

        var parts = null;
        var timeParts = null;
        var dateTimeParts = yyyyMMddDate.split(dateTimeSep);
        if (dateTimeParts.length > 0){
            parts = dateTimeParts[0].split(dateSep);
            if (dateTimeParts.length > 1){
                timeParts = dateTimeParts[1].split(timeSep);
            }
        }
        if (parts === null){
            return null;
        }

        var mydate = null;
        if ((timeParts === null) || (timeParts === undefined) || (timeParts.length < 1)){
            mydate = new Date(parts[0], parts[1]-1, parts[2]); 
        }else{
            mydate = new Date(parts[0], parts[1]-1, parts[2], timeParts[0], timeParts[1]); 
        }
        return mydate;
    }

    convertToDate3(yyyyMMddDate){
        if ((yyyyMMddDate === null) || (yyyyMMddDate === undefined)){
            return null;
        }
        var dateSep = '-';
        var dateTimeSep = ' ';
        var timeSep = ':';

        var parts = null;
        var timeParts = null;
        var dateTimeParts = yyyyMMddDate.split(dateTimeSep);
        if (dateTimeParts.length > 0){
            parts = dateTimeParts[0].split(dateSep);
            if (dateTimeParts.length > 1){
                timeParts = dateTimeParts[1].split(timeSep);
            }
        }
        if (parts === null){
            return null;
        }

        var mydate = null;
        if ((timeParts === null) || (timeParts === undefined) || (timeParts.length < 1)){
            mydate = new Date(parts[0], parts[1]-1, parts[2]); 
        }else{
            mydate = new Date(parts[0], parts[1]-1, parts[2], timeParts[0], timeParts[1]); 
        }
        mydate = new Date(parts[0], parts[1]-1, parts[2]); 
        return mydate;
    }         

    convertToyyyyMMddhhmmString(date){
        if (date === null || date === undefined){
            return ''
        }
        var iMonth = date.getMonth() + 1;
        var sDate = date.getFullYear() + "/" + this.formatDateTimeValue(iMonth) + 
            "/" + this.formatDateTimeValue(date.getDate()) + " " + 
            this.formatDateTimeValue(date.getHours()) + ":" + this.formatDateTimeValue(date.getMinutes());
        return sDate;
    }

    convertToyyyyMMddString(date){
        if (date === null || date === undefined){
            return ''
        }
        var iMonth = date.getMonth() + 1;
        var sDate = date.getFullYear() + "/" + this.formatDateTimeValue(iMonth) + 
            "/" + this.formatDateTimeValue(date.getDate());
        return sDate;
    }

    formatDateTimeValue(value){
        if ((value === null) || (value === undefined)){
            return "00";
        }
        if (value < 10){
            return "0" + value;
        }
        return value;
    }

    getItem (key) {
        let value = sessionStorage.getItem(key);
        return value === null || value === '' || value === 'null' ? undefined: value
    }
    saveItem(key, value){
        if (value !== undefined && value !== 'null' && value !== ''){
        sessionStorage.setItem(key, value);
        }
    }
    removeItem(key){
        sessionStorage.removeItem(key);
    }

    getItemFromStorage (key) {
        let value = localStorage.getItem(key);
        return value === null || value === '' || value === 'null' ? '': value
    }
    saveItemToStorage(key, value){
        console.log(key, value);
        if (value !== undefined && value !== 'null' && value !== ''){
            localStorage.setItem(key, value);
        }
    }
    removeItemFromStorage(key){
        localStorage.removeItem(key);
    }   
}

export default new WorkOrderUtil();